import React from "react";

const Footer = () => {
  return (
    <div style={{textAlign:"center", marginTop:"5px"}}>
      <hr style={{ color: "grey" ,margin:"0",borderColor:"grey"}} />
      <h4 style={{color:"grey", margin:"auto",padding:"8px"}}>Copyright &copy; Yidi Wang 2020</h4>
    </div>
  );
};

export default Footer;
